// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__layout,#__nuxt,body,html{width:100%;height:100%}body{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
